import { Component, Input } from '@angular/core';
import { StaticPagesService } from 'src/app/Services/static-pages.service';
import { EmbryoService } from '../../../Services/Embryo.service';
// import { environmentVariables } from 'src/environments/enviromentalVariables';

@Component({
  selector: 'embryo-FixedHeader',
  templateUrl: './FixedHeader.component.html',
  styleUrls: ['./FixedHeader.component.scss'],
})
export class FixedHeaderComponent {
  @Input() lang: any;
  environmentVariables: any;
   changeIconFill:boolean = true;
  constructor(
    private embryoService: EmbryoService,
    private confgServ: StaticPagesService
  ) {
    this.getInitilizingData();
  }

  public toggleSidebar() {
    this.embryoService.sidenavOpen = !this.embryoService.sidenavOpen;
  }
  getInitilizingData() {
    this.confgServ.getenvConfig().subscribe((res) => {
      this.environmentVariables = res;
    });
  }
}
